export default __webpack_public_path__ + "static/media/ic_ceuta.87670505.svg";